import { defineStore } from 'pinia'
import type { User } from '../types'

const TOKEN_KEY = 'nginx-ui.token'
const USER_KEY = 'nginx-ui.user'

export const useAuth = defineStore('auth', {
  state: () => ({
    token: '' as string,
    user: null as User | null,
  }),
  getters: {
    isAdmin: (state) => state.user?.role === 'admin',
    isCustomer: (state) => state.user?.role === 'customer',
  },
  actions: {
    hydrate() {
      this.token = localStorage.getItem(TOKEN_KEY) || ''
      const raw = localStorage.getItem(USER_KEY)
      this.user = raw ? JSON.parse(raw) : null
    },
    setSession(token: string, user: User) {
      this.token = token
      this.user = user
      localStorage.setItem(TOKEN_KEY, token)
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    },
    logout() {
      this.token = ''
      this.user = null
      localStorage.removeItem(TOKEN_KEY)
      localStorage.removeItem(USER_KEY)
    },
  },
})
